export default {
  INBOUND: 'inbound',
  OUTBOUND: 'outbound',
};



// WEBPACK FOOTER //
// ./src/variables/tripDirections.js